import AttemptPopup from './AttemptPopup';
import { Table } from '../../../components';

import React from 'react';
import PropTypes from 'prop-types';
import { last } from 'lodash';

const AttemptCell = ({
  title,
  declarations,
  attempt,
  result,
  actions,
  ...props
}) => {
  const declaration = last(declarations);

  let state = 'empty';
  let content = ' ';

  if (attempt && attempt.decision) {
    if (attempt.weight) {
      const { isGoodLift } = attempt.decision;
      if (isGoodLift) {
        state = 'good lift';
        content = attempt.weight;
      } else {
        state = 'no lift';
        content = `-${attempt.weight}`;
      }
    } else {
      state = 'omitted';
      content = '---';
    }
  } else if (declaration) {
    state = 'declared';
    content = <i>'{declaration.weight}</i>;
  } else if (result !== undefined) {
    state = 'omitted';
    content = '---';
  }

  const stateProps = {
    declared: { warning: true },
    'good lift': { positive: true },
    'no lift': { negative: true },
  };

  const cellProps = {
    ...(stateProps[state] || {}),
    ...props,
  };

  /*
  const onContentClick = event => {
    event.preventDefault();
    event.nativeEvent.stopImmediatePropagation();
  };
  */
  const aStyle = { cursor: 'pointer' };
  // FIXME: Creating trigger from function causes popup to jump!
  return (
    <Table.Cell selectable {...cellProps}>
      <AttemptPopup
        trigger={<a style={aStyle}>{content}</a>}
        title={title}
        declarations={declarations}
        attempt={attempt}
        actions={actions}
      />
    </Table.Cell>
  );
};

AttemptCell.propTypes = {
  title: PropTypes.string.isRequired,
  declarations: PropTypes.array.isRequired,
  attempt: PropTypes.object,
  actions: PropTypes.shape({
    declaration: PropTypes.func.isRequired,
    decision: PropTypes.func.isRequired,
  }).isRequired,
};

export default AttemptCell;



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/AttemptCell.js